<template>
  <div class="app-shell home-page info-page">
    <div class="app-shell__main">
      <AppHeader />

      <main class="info-main">
        <section class="info-hero info-hero--statement">
          <div class="info-badge">Service Statement</div>
          <h1 class="info-title">服务声明</h1>
          <p class="info-description">为了便于你了解服务范围、使用边界、权益说明与责任限制，我们把核心条款整理成一页说明，帮助你在使用前快速查看。</p>
          <div class="info-meta">生效日期：2026 年 4 月 3 日</div>
          <div class="info-summary">
            <article v-for="item in summary" :key="item.title" class="info-summary-card">
              <strong>{{ item.title }}</strong>
              <span>{{ item.text }}</span>
            </article>
          </div>
        </section>

        <section class="info-panel">
          <div class="info-note-panel">
            <h3>重点提示</h3>
            <ul class="info-points">
              <li>你访问和使用本站服务的行为，视为已知悉并同意本声明全部内容。</li>
              <li>本服务仅提供技术工具能力，不代表对第三方平台内容作出授权、背书或保证。</li>
              <li>若涉及会员、积分、充值或其他数字化权益，请以网站内实际展示规则为准。</li>
              <li>若你不同意本声明任一内容，请立即停止使用相关服务。</li>
            </ul>
          </div>

          <div class="info-section-head">
            <h2 class="section-title">服务条款</h2>
            <p>以下内容结合当前网站能力和参考说明整理，便于网页端用户快速理解使用边界。</p>
          </div>

          <div class="info-card-list">
            <article v-for="item in statements" :key="item.id" class="info-card">
              <div class="info-card__head">
                <div class="info-card__index">{{ item.id }}</div>
                <h3 class="info-card__title">{{ item.title }}</h3>
              </div>
              <p class="info-card__description">{{ item.description }}</p>
              <ul class="info-points">
                <li v-for="point in item.points" :key="point">{{ point }}</li>
              </ul>
            </article>
          </div>

          <div class="info-note-panel">
            <h3>联系与说明</h3>
            <p class="info-note-panel__text">如需咨询服务使用、充值记录、侵权投诉或正式通知，请优先通过站内客服入口联系；若需要邮件沟通，可发送至 <a href="mailto:adaiyuns@163.com">adaiyuns@163.com</a>。</p>
          </div>
        </section>
      </main>
    </div>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'ServiceStatement',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      summary: [
        { title: '工具属性', text: '本站提供公开分享内容的提取、解析、下载与基础处理辅助功能，实际能力以页面展示为准。' },
        { title: '使用前提', text: '你应确保处理内容来源合法，并在合理、必要、合规的范围内使用相关功能和结果。' },
        { title: '风险提示', text: '受平台规则、网络环境、版权限制、设备状态等影响，部分功能可能失败、延迟或无法使用。' }
      ],
      statements: [
        {
          id: '1',
          title: '服务说明',
          description: '本站属于工具类网站，主要提供公开分享内容的提取、解析、下载和基础处理等辅助功能。',
          points: ['具体可用功能以页面实际展示为准。', '本服务不构成对第三方内容的任何授权或承诺。', '受平台策略、网络环境、版权限制等影响，部分内容可能无法成功解析、下载或处理。']
        },
        {
          id: '2',
          title: '使用范围与用户义务',
          description: '你应在合法、正当、必要的范围内使用本服务，并对所处理内容的来源与用途自行负责。',
          points: ['请确保对所处理内容享有合法来源，或已取得必要授权。', '处理结果建议仅用于个人学习、研究、备份或合理欣赏等合法用途。', '不得利用本服务从事侵犯著作权、肖像权、隐私权等违法违规行为。']
        },
        {
          id: '3',
          title: '知识产权与内容归属',
          description: '第三方平台上的图片、视频、音频、文案及其他内容，其知识产权及相关权益归原平台、原作者或合法权利人所有。',
          points: ['本站仅提供技术处理能力，不因你的使用而取得相关内容的任何权利。', '本服务不会向你转授任何知识产权许可，也不改变原内容权属关系。']
        },
        {
          id: '4',
          title: '关于存储、传输与处理结果',
          description: '本服务原则上仅在实现功能所必需的范围内进行临时处理，不以长期托管、转售或传播第三方内容为目的。',
          points: ['处理结果可能出现清晰度变化、格式变化、内容缺失、保存失败或处理失败等情况。', '你应自行核对结果内容，并判断是否满足自身需求。']
        },
        {
          id: '5',
          title: '充值、会员与付费说明',
          description: '如页面涉及积分、会员、充值或其他付费权益，请以网站内支付页或服务页的说明为准。',
          points: ['价格、权益范围、有效期、次数规则等以页面展示内容为准。', '到账延迟、状态未同步等客观异常，可凭支付记录联系客服核实。', '除法律法规另有规定外，已实际履行的数字化服务一般不支持无理由退款。']
        },
        {
          id: '6',
          title: '第三方平台与外部链接',
          description: '本服务可能涉及对第三方平台分享链接、公开页面或相关资源的识别与处理，相关外部平台规则可能随时调整。',
          points: ['第三方平台规则变化，均可能导致功能失败、中断或调整。', '你在使用第三方平台内容时，还应同时遵守该平台的用户协议和版权规范。']
        },
        {
          id: '7',
          title: '责任限制与免责',
          description: '我们会尽力保持服务稳定、安全与连续，但无法就所有设备、网络和场景下的绝对效果作出保证。',
          points: ['本服务不承诺完全不中断、无故障、无延迟。', '对因用户操作不当、设备问题、网络异常、第三方原因或不可抗力造成的异常和损失，在法律允许范围内不承担责任。']
        },
        {
          id: '8',
          title: '联系我们',
          description: '如你对本声明、充值记录、服务使用或其他事项有疑问，可通过官方渠道联系处理。',
          points: ['站内优先使用客服入口联系。', '如涉及正式通知或版权合作，可发送邮件至 adaiyuns@163.com。']
        }
      ]
    }
  }
}
</script>
